import { render, staticRenderFns } from "./returnInfo.vue?vue&type=template&id=1a5142c3&scoped=true"
import script from "./returnInfo.vue?vue&type=script&lang=js"
export * from "./returnInfo.vue?vue&type=script&lang=js"
import style0 from "./returnInfo.vue?vue&type=style&index=0&id=1a5142c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5142c3",
  null
  
)

export default component.exports